import dayjs from 'dayjs';

import {TIME_FORMATS} from '@/utils/timeFormats';

export const WEEK_DAYS_MONDAY_FIRST = [1, 2, 3, 4, 5, 6, 0] as const;

export type WeekDayNumber = (typeof WEEK_DAYS_MONDAY_FIRST)[number];

export function capitalizeDayName(dayName: string) {
  return dayName.charAt(0).toUpperCase() + dayName.slice(1).toLowerCase();
}

export function getWeekDayLongName(day: number) {
  return capitalizeDayName(dayjs().day(day).format(TIME_FORMATS.dayLong));
}

export function getWeekDayShortName(day: number) {
  return capitalizeDayName(dayjs().day(day).format(TIME_FORMATS.dayShort));
}

export function getWeekDayOptions() {
  return WEEK_DAYS_MONDAY_FIRST.map(day => ({
    value: day,
    label: getWeekDayLongName(day),
    shortLabel: getWeekDayShortName(day),
  }));
}

export function getSortedWeekDays(daysOfWeek: (number | null)[] = []) {
  const selectedDays = new Set(
    daysOfWeek.filter((day): day is number => typeof day === 'number')
  );

  return WEEK_DAYS_MONDAY_FIRST.filter(day => selectedDays.has(day));
}

export function formatWeekDaysShort(daysOfWeek: (number | null)[] = []) {
  return getSortedWeekDays(daysOfWeek).map(getWeekDayShortName).join(', ');
}
